// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__RGKS3","title":"AfterFrontImage_title__3gOcK"};